import { render } from "./DetectorsInfo.vue?vue&type=template&id=e7e2b970&ts=true"
import script from "./DetectorsInfo.vue?vue&type=script&lang=ts"
export * from "./DetectorsInfo.vue?vue&type=script&lang=ts"

import "./DetectorsInfo.vue?vue&type=style&index=0&id=e7e2b970&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__